var ko = require('knockout');

// Use this binding on a form element to ensure that the form won't submit
// twice if the user double-clicks the submit button.
//
// Examples
//
//    data-bind="preventDoubleSubmit: true"
//
module.exports = {
  init: function(element, valueAccessor) {
    if (ko.utils.unwrapObservable(valueAccessor())) {
      var $form = $(element);
      var $submits = $form.find('input[type=submit]');
      $form.submit(function() {
        $submits.attr('disabled', 'disabled');
      });

      // Make sure the submit button is re-enabled if the user navigates back to a cached page
      $submits.removeAttr('disabled');
    }
  }
};
